module.exports = __webpack_public_path__ + "static/media/compare.3eb6f562.svg";